export enum Actions {
  polygonToRaster = 'rasterWorker:polygonToRaster',
  fillFromPointOnRaster = 'rasterWorker:fillFromPointOnRaster',
}
